import React, {useEffect, useState} from 'react';
import {Button, Form, Modal, Select} from 'antd';
import {useDispatch} from 'react-redux';
import {getFilterBranch} from "../../microComponents/tablePages/getFilterBranch";
import {getFilterLocation} from "../../microComponents/tablePages/getFilterLocation";
import {getFilterRows} from "../../microComponents/tablePages/getFilterRows";
import {handleEntry} from "../../store/SettingRedux/SettingRedux";

const QcModal = () => {
    const [form] = Form.useForm();

     const [open, setOpen] = useState(false);
    const dispatch = useDispatch();
    const [selectedBranch, setSelectedBranch] = useState();
    const [branchList, setBranchList] = useState([]);
    const [branchLoading, setBranchLoading] = useState(false);
    const [selectedLocation, setSelectedLocation] = useState();
    const [locationList, setLocationList] = useState([]);
    const [locationLoading, setLocationLoading] = useState(false);
    const [RowList, setRowList] = useState([]);
    const [RowLoading, setRowLoading] = useState(false);
    const [IsExit, setIsExit] = useState();

    useEffect(() => {
        if (open) {

            getFilterBranch((e) => {
                setBranchList(e)
                setSelectedBranch(e[0]?.value)
                form.setFieldValue('branch', e[0]?.value)
            }, setBranchLoading)
        }


    }, [open,form]);

    useEffect(() => {
        if (selectedBranch) {

            getFilterLocation((e) => {
                setLocationList(e)
                setSelectedLocation(e[0]?.value)
                form.setFieldValue('location', e[0]?.value)


            }, setLocationLoading, selectedBranch)

        }


    }, [selectedBranch,form]);
    useEffect(() => {
        if (selectedLocation) {
            getFilterRows((e) => {
                setRowList(e)

                form.setFieldValue('rowId', e[0]?.value)


            }, setRowLoading, selectedLocation)

        }
    }, [selectedLocation,form]);
    useEffect(() => {
        if (open) {
            form.submit()

        }
    }, [IsExit,open,form]);


    const handleShow = () => {

        setOpen(true);

    };


    const handleCancel = () => {
        setOpen(false);
    };

    const onFinish = (values) => {
        handleCancel()
        values.IsExit = IsExit
        dispatch(handleEntry(values))
    }
    const onFinishFailed = () => {
    }

    return (<>
            <div>
                <Button className='defBtn blueBtn' onClick={handleShow}> ورود / خروج</Button>

                <Modal
                    open={open}
                    title='ورود / خروج'
                    onOk={onFinish}
                    onCancel={handleCancel}
                    footer={[<Button className='defBtn redBtn' key='back' onClick={handleCancel}>
                        انصراف
                    </Button>, <Button className='defBtn orangeBtn !px-6' key='submit' type='primary'
                                       onClick={() => {
                                           setIsExit(true)
                                           form.submit()
                                       }}>
                        ثبت خروج
                    </Button>, <Button className='defBtn blueBtn !px-6' key='submit' type='primary'
                                       onClick={() => {
                                           setIsExit(false)
                                           form.submit()
                                       }}>
                        ثبت ورود
                    </Button>,

                    ]}
                >

                    <Form
                        name="basic"
                        form={form}
                        layout='vertical'
                        onFinish={onFinish}
                        onFinishFailed={onFinishFailed}
                        autoComplete="off"
                    >


                        <Form.Item
                            name="branch"
                            label="واحد"
                            rules={[{
                                required: true, message: 'لطفا واحد را وارد کنید!',
                            },]}
                            hasFeedback
                        >
                            <Select showSearch onChange={setSelectedBranch}
                                    loading={branchLoading}
                                    filterOption={(input, option) => {
                                        return (option?.label.toLowerCase() ?? '').includes(input.toLowerCase())
                                    }}
                                    optionFilterProp='label'
                                    options={branchList}/>

                        </Form.Item>


                        <Form.Item


                            name="location"
                            label="انبار"
                            rules={[{
                                required: true, message: 'لطفا انبار را وارد کنید!',
                            },]}
                            hasFeedback
                        >
                            <Select showSearch placeholder='انبار' onChange={setSelectedLocation}
                                    loading={locationLoading}
                                    filterOption={(input, option) => {
                                        return (option?.label.toLowerCase() ?? '').includes(input.toLowerCase())
                                    }}
                                    optionFilterProp='label'
                                    options={locationList}/>


                        </Form.Item>

                        <Form.Item


                            name="rowId"
                            label="ردیف"
                            rules={[{
                                required: true, message: 'لطفا ردیف را وارد کنید!',
                            },]}
                            hasFeedback
                        >
                            <Select showSearch
                                    loading={RowLoading}
                                    filterOption={(input, option) => {
                                        return (option?.label.toLowerCase() ?? '').includes(input.toLowerCase())
                                    }}
                                    optionFilterProp='label'
                                    options={RowList}/>


                        </Form.Item>


                    </Form>


                </Modal>
            </div>
        </>

    );
};
export default QcModal;